import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { RemoveIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const QuizFeedback = ({
  correctAnswer,
  onTryAgainClick,
  children
}) => /*#__PURE__*/_jsxs(View, {
  backgroundColor: "fill-surface-default",
  borderColor: "border-core-default",
  borderRadius: "100",
  borderStyle: "solid",
  borderWidth: "100",
  "data-test-id": "quiz-feedback",
  "data-test-info-quiz-feedback": correctAnswer,
  paddingBlock: "800",
  paddingInline: "800",
  children: [/*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(IconCircle, {
      backgroundColor: correctAnswer ? 'fill-positive-default' : 'fill-alert-default',
      borderColor: correctAnswer ? 'border-positive-default' : 'border-alert-default',
      color: "fill-surface-default",
      icon: correctAnswer ? SuccessIcon : RemoveIcon,
      size: "100"
    }), /*#__PURE__*/_jsx(Text, {
      as: "strong",
      color: correctAnswer ? 'fill-positive-default' : 'text-alert-default',
      marginInlineStart: "400",
      children: correctAnswer ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.quiz.thatsRight"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.quiz.notQuite"
      })
    })]
  }), /*#__PURE__*/_jsx(View, {
    marginBlock: "400",
    children: children
  }), correctAnswer ? null : /*#__PURE__*/_jsx(Button, {
    "data-test-id": "quiz-feedback-retry",
    id: "ignore-enter-proceed",
    onClick: onTryAgainClick,
    use: "tertiary",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.quiz.tryAgain"
    })
  })]
});
export default QuizFeedback;